'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const WizardSidebarTimelineDoneIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="WizardSidebarTimelineDoneIcon">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8" fill="#5073C3" stroke="#5073C3" strokeWidth="2" />
        <path d="M4.5 9.5625L7.3125 12.375L12.9375 6.75" stroke="white" strokeLinecap="round" />
      </svg>
    </SvgIcon>
  )
}

WizardSidebarTimelineDoneIcon.propTypes = {
  sx: PropTypes.object
}
